import { render, staticRenderFns } from "./FacebookOriginalPost.vue?vue&type=template&id=d7e4b7c4&"
import script from "./FacebookOriginalPost.vue?vue&type=script&lang=js&"
export * from "./FacebookOriginalPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports